<template>
  <div class="home-view">
    <h4>多发性骨髓(MM)相关静脉血栓栓塞症(VTE)风险分层调查问卷</h4>
    <van-form
      @submit="onSubmit"
      label-width="140px"
      @failed="onFailed"
      ref="form"
    >
      <p class="title">患者基本信息</p>
      <div class="card">
        <!-- 患者姓名 -->
        <van-field
          v-model="form.patientName"
          name="patientName"
          label="患者姓名"
          placeholder="请输入患者姓名"
          :rules="[{ required: true, message: '请填写患者姓名' }]"
        />

        <!-- 患者身份证号 -->
        <!-- <van-field
          v-model="form.patientIdCard"
          name="patientIdCard"
          label="患者身份证号"
          placeholder="请输入身份证号"
          :rules="[
            { required: true, message: '请填写身份证号' },
            { pattern: /^\d{18}$/, message: '身份证号应为18位数字' },
          ]"
          @blur="inputIdCard"
        >
        </van-field> -->

        <!-- 性别 -->
        <van-field
          label="性别"
          placeholder="请选择性别"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择性别' }]"
          :disabled="isCalc"
        >
          <template #input>
            <van-radio-group
              v-model="form.gender"
              direction="horizontal"
              :disabled="isCalc"
            >
              <van-radio name="男">男</van-radio>
              <van-radio name="女">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 年龄 -->
        <van-field
          v-model="form.age"
          name="age"
          label="年龄"
          type="number"
          placeholder="请输入年龄"
          :rules="[{ required: true, message: '请填写年龄' }]"
          :disabled="isCalc"
          @change="changeAge"
        >
        </van-field>

        <!-- 住院号 -->
        <van-field
          v-model="form.inNumber"
          name="inNumber"
          label="住院号"
          type="number"
          placeholder="请输入住院号"
          :rules="[{ required: true, message: '请填写住院号' }]"
        >
        </van-field>

        <!-- 诊断 -->
        <van-field
          v-model="form.diagnosis"
          name="diagnosis"
          label="诊断"
          placeholder="请输入诊断"
          type="textarea"
          :rules="[{ required: true, message: '请填写诊断' }]"
        >
        </van-field>

         <!-- ISS分期 -->
         <van-field
          v-model="form.iss"
          name="iss"
          label="ISS分期"
          placeholder="请输入ISS分期"
          :rules="[{ required: true, message: '请填写ISS分期' }]"
        >
        </van-field>

        <!-- 患者手机号码 -->
        <van-field
          v-model="form.patientPhone"
          name="patientPhone"
          label="患者手机号码"
          placeholder="请输入手机号码"
          :rules="[
            { required: true, message: '请填写手机号码' },
            { pattern: /^[\d\-]+$/, message: '手机号码只能包含数字和破折号' },
          ]"
        />
      </div>
      <p class="title">个体和疾病因素</p>
      <div class="card">
        <!-- 遗传性易栓症 -->
        <van-field
          v-model="form.hereditaryThrombophilia"
          name="hereditaryThrombophilia"
          label="遗传性易栓症"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择遗传性易栓症' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.hereditaryThrombophilia"
              direction="horizontal"
            >
              <van-radio name="是">是(6)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- VTE家族史 -->
        <van-field
          v-model="form.vteFamilyHistory"
          name="vteFamilyHistory"
          label="VTE家族史"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择VTE家族史' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.vteFamilyHistory"
              direction="horizontal"
            >
              <van-radio name="是">是(5)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.vteHistory"
          name="vteHistory"
          label="VTE病史"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择VTE病史' }]"
        >
          <template #input>
            <van-radio-group v-model="form.vteHistory" direction="horizontal">
              <van-radio name="是">是(5)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.lupusAnticoagulantPositive"
          name="lupusAnticoagulantPositive"
          label="狼疮抗凝物阳性"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择狼疮抗凝物阳性' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.lupusAnticoagulantPositive"
              direction="horizontal"
            >
              <van-radio name="是">是(4)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.pelvisFracture"
          name="pelvisFracture"
          label="骨盆、臀部或股骨骨折"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择骨盆、臀部或股骨骨折' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.pelvisFracture"
              direction="horizontal"
            >
              <van-radio name="是">是(4)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.superficialVeinThrombosisHistory"
          name="superficialVeinThrombosisHistory"
          label="浅静脉血栓病史"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择浅静脉血栓病史' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.superficialVeinThrombosisHistory"
              direction="horizontal"
            >
              <van-radio name="是">是(3)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.bedriddenDuration"
          name="bedriddenDuration"
          label="患者需要卧床超过72 h"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择患者需要卧床超过72 h' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.bedriddenDuration"
              direction="horizontal"
            >
              <van-radio name="是">是(2)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.majorSurgeryTime"
          name="majorSurgeryTime"
          label="大手术（1个月内）"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择大手术（1个月内）' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.majorSurgeryTime"
              direction="horizontal"
            >
              <van-radio name="是">是(2)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.antiCardiolipinAntibodyPositive"
          name="antiCardiolipinAntibodyPositive"
          label="抗心磷脂抗体阳性"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择抗心磷脂抗体阳性' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.antiCardiolipinAntibodyPositive"
              direction="horizontal"
            >
              <van-radio name="是">是(2)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!-- 年龄 > 75岁 -->
        <van-field
          v-model="form.ageOver75"
          name="ageOver75"
          label="年龄>75岁"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择年龄>75岁' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.ageOver75"
              direction="horizontal"
              :disabled="isCalc"
            >
              <van-radio name="是">是(2)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.age60To75"
          name="age60To75"
          label="年龄60~75岁"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择年龄60~75岁' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.age60To75"
              direction="horizontal"
              :disabled="isCalc"
            >
              <van-radio name="是">是(1)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 体质指数 -->
        <van-field
          v-model="form.height"
          name="height"
          label="身高(cm)"
          placeholder="请输入身高"
          @blur="(val) => calcBodyMassIndex(val)"
          :rules="[{ required: true, message: '请填写身高' }]"
        />
        <van-field
          v-model="form.weight"
          name="weight"
          label="体重(kg)"
          placeholder="请输入体重"
          @blur="(val) => calcBodyMassIndex(val)"
          :rules="[{ required: true, message: '请填写体重' }]"
        >
        </van-field>
        <van-field
          v-model="form.bodyMassIndex"
          name="bodyMassIndex"
          label="体质指数评分"
          placeholder="自动计算"
          readonly
        />

        <van-field
          v-model="form.mproteinConcentration"
          name="mproteinConcentration"
          label="M蛋白浓度≥30 g/L"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择M蛋白浓度≥30 g/L' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.mproteinConcentration"
              direction="horizontal"
            >
              <van-radio name="是">是(1)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-model="form.congestiveHeartFailureTime"
          name="congestiveHeartFailureTime"
          label="充血性心力衰竭（1个月内）"
          placeholder="请选择"
          readonly
          clickable
          :rules="[
            { required: true, message: '请选择充血性心力衰竭（1个月内）' },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="form.congestiveHeartFailureTime"
              direction="horizontal"
            >
              <van-radio name="是">是(1)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-model="form.acuteMyocardialInfarction"
          name="acuteMyocardialInfarction"
          label="急性心肌梗死"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择急性心肌梗死' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.acuteMyocardialInfarction"
              direction="horizontal"
            >
              <van-radio name="是">是(1)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.pulmonaryFunctionAbnormal"
          name="pulmonaryFunctionAbnormal"
          label="肺功能异常（慢性阻塞性肺疾病）"
          placeholder="请选择"
          readonly
          clickable
          :rules="[
            { required: true, message: '请选择肺功能异常（慢性阻塞性肺疾病）' },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="form.pulmonaryFunctionAbnormal"
              direction="horizontal"
            >
              <van-radio name="是">是(1)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.diabetes"
          name="diabetes"
          label="糖尿病"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择糖尿病' }]"
        >
          <template #input>
            <van-radio-group v-model="form.diabetes" direction="horizontal">
              <van-radio name="是">是(1)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.nephroticSyndrome"
          name="nephroticSyndrome"
          label="肾病综合征"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择肾病综合征' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.nephroticSyndrome"
              direction="horizontal"
            >
              <van-radio name="是">是(1)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>

      <p class="title">治疗因素</p>

      <div class="card">
        <!-- 免疫调节剂 -->
        <van-field
          v-model="form.immunomodulator"
          name="immunomodulator"
          label="免疫调节剂"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择免疫调节剂' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.immunomodulator"
              direction="horizontal"
              @change="handleImmunomodulatorsChange"
            >
              <van-radio name="是">是(4)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-model="form.dexamethasoneTotalPerCycleHigh"
          name="dexamethasoneTotalPerCycleHigh"
          label="每周期地塞米松总量＞160 mg"
          placeholder="请选择"
          readonly
          clickable
          :rules="[
            { required: true, message: '请选择每周期地塞米松总量＞160 mg' },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="form.dexamethasoneTotalPerCycleHigh"
              direction="horizontal"
            >
              <van-radio name="是">是(4)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-model="form.dexamethasoneTotalPerCycleMiddle"
          name="dexamethasoneTotalPerCycleMiddle"
          label="每周期地塞米松总量120～160 mg"
          placeholder="请选择"
          readonly
          clickable
          :rules="[
            { required: true, message: '请选择每周期地塞米松总量120～160 mg' },
          ]"
        >
          <template #input>
            <van-radio-group
              v-model="form.dexamethasoneTotalPerCycleMiddle"
              direction="horizontal"
            >
              <van-radio name="是">是(2)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.anthracyclineBasedChemotherapy"
          name="anthracyclineBasedChemotherapy"
          label="蒽环类为主的多药化疗"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择蒽环类为主的多药化疗' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.anthracyclineBasedChemotherapy"
              direction="horizontal"
            >
              <van-radio name="是">是(3)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-model="form.carfilzomib"
          name="carfilzomib"
          label="卡非佐米"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择卡非佐米' }]"
        >
          <template #input>
            <van-radio-group v-model="form.carfilzomib" direction="horizontal">
              <van-radio name="是">是(2)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.centralVenousCatheter"
          name="centralVenousCatheter"
          label="中心静脉置管"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择中心静脉置管' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.centralVenousCatheter"
              direction="horizontal"
            >
              <van-radio name="是">是(2)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.erythropoietin"
          name="erythropoietin"
          label="促红细胞生成素"
          placeholder="请选择"
          readonly
          clickable
          :rules="[{ required: true, message: '请选择促红细胞生成素' }]"
        >
          <template #input>
            <van-radio-group
              v-model="form.erythropoietin"
              direction="horizontal"
            >
              <van-radio name="是">是(1)</van-radio>
              <van-radio name="否">否(0)</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          v-model="form.submitDoctor"
          name="submitDoctor"
          label="提交医生"
          placeholder="请输入提交医生"
          :rules="[{ required: true, message: '请填写提交医生' }]"
        />

        <van-field
          v-model="form.hospitalName"
          name="hospitalName"
          label="所属医院"
          placeholder="请输入所属医院"
          :rules="[{ required: true, message: '请填写所属医院' }]"
        />
      </div>

      <!-- 提交按钮 -->
      <div style="margin: 16px">
        <van-button
          block
          type="info"
          @click="onSubmit"
          style="background-color: #2eb16e; border-radius: 4px; font-size: 16px"
        >
          提 交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
  import {
    Form,
    Field,
    RadioGroup,
    Radio,
    Checkbox,
    Stepper,
    Button,
    Toast,
    Dialog,
  } from 'vant';

  import axios from 'axios';
  export default {
    data() {
      return {
        form: {
          id: '',
          patientName: '',
          patientIdCard: '',
          gender: '',
          age: '',
          patientPhone: '',
          hereditaryThrombophilia: '',
          vteFamilyHistory: '',
          vteHistory: '',
          lupusAnticoagulantPositive: '',
          pelvisFracture: '',
          superficialVeinThrombosisHistory: '',
          bedriddenDuration: '',
          majorSurgeryTime: '',
          antiCardiolipinAntibodyPositive: '',
          ageOver75: '',
          age60To75: '',
          bodyMassIndex: '',
          mproteinConcentration: '',
          congestiveHeartFailureTime: '',
          acuteMyocardialInfarction: '',
          pulmonaryFunctionAbnormal: '',
          diabetes: '',
          nephroticSyndrome: '',
          immunomodulator: '',
          dexamethasoneTotalPerCycleHigh: '',
          dexamethasoneTotalPerCycleMiddle: '',
          anthracyclineBasedChemotherapy: '',
          carfilzomib: '',
          centralVenousCatheter: '',
          erythropoietin: '',
          submitDoctor: '',
          hospitalName: '',
          height: '',
          weight: '',
        },
        copyForm: {},
        isCalc: false,
      };
    },
    methods: {
      changeAge() {
        console.log(this.form.age);
        if (this.form.age > 75) {
          this.form.ageOver75 = '是';
          this.form.age60To75 = '否';
        } else {
          this.form.ageOver75 = '否';
        }

        if (this.form.age < 75 && this.form.age > 65) {
          this.form.age60To75 = '是';
        } else {
          this.form.age60To75 = '否';
        }
      },
      calcBodyMassIndex(val) {
        // 计算体脂
        if (this.form.height && this.form.weight) {
          this.form.bodyMassIndex = (
            this.form.weight /
            ((this.form.height / 100) * (this.form.height / 100))
          ).toFixed(2);
        }
      },
      calculateBMI() {},
      handleImmunomodulatorsChange() {},
      async onFailed() {
        Toast.fail('请检查是否填写完整');
      },
      async onSubmit(values) {
        console.log();

        await this.$refs.form.validate();
        // 提交表单  先获取分数

        this.copyForm = JSON.parse(JSON.stringify(this.form));
        // 把form中的 是 转换为true 否 转换为false
        for (let key in this.copyForm) {
          if (this.copyForm[key] === '是') {
            this.copyForm[key] = true;
          } else if (this.copyForm[key] === '否') {
            this.copyForm[key] = false;
          }
        }

        // 体质指数如果大于 25 为true 否则为false
        if (this.copyForm.bodyMassIndex >= 25) {
          this.copyForm.bodyMassIndex = 1;
        } else {
          this.copyForm.bodyMassIndex = 0;
        }

        let score = '';
        let result = '';

        let str = `分数：${score}，\n结果：${result}`;
        let res = await axios.post(
          'https://vet-phone.portolanalytica.cn/api/vetSurvey/score',
          this.copyForm
        );
        console.log(res.data);
        result = this.calcMedical(res.data);
        Dialog.alert({
          title: '',
          showCancelButton: true,
          message: `分数：${res.data}\n推荐用药：${result}`,
        })
          .then(() => {
            // on confirm
            // 提交表单
            this.submitForm();
          })
          .catch(() => {
            // on cancel
          });
      },

      submitForm() {
        axios
          .post(
            'https://vet-phone.portolanalytica.cn/api/vetSurvey/insert',
            this.copyForm
          )
          .then(function (response) {
            Toast.success('提交成功');
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      calcMedical(val) {
        let res = '';
        if (val < 6) {
          res = '不建议药物预防';
        }
        if (val >= 6 && val <= 8) {
          res = '阿司匹林';
        }
        if (val >= 9 && val <= 12) {
          res = '华法林(维持凝血酶原时间国际标准化比值2~3),预防剂量低分子肝素(LMWH)或直接口服抗凝剂(DOAC)';
        }
        if (val >= 13) {
          res = '治疗剂量LMWH或DOAC';
        }

        return res;
      },

      calculateAgeAndGender(idNumber) {
        // 验证身份证号码长度
        if (idNumber.length != 18) {
          return { age: '', gender: '' };
        }

        // 提取出生日期
        var birthYear = parseInt(idNumber.substring(6, 10), 10);
        var birthMonth = parseInt(idNumber.substring(10, 12), 10);
        var birthDay = parseInt(idNumber.substring(12, 14), 10);

        // 计算年龄
        var today = new Date();
        var age =
          today.getFullYear() -
          birthYear -
          (today.getMonth() + 1 < birthMonth ||
          (today.getMonth() + 1 === birthMonth && today.getDate() < birthDay)
            ? 1
            : 0);

        // 判断性别
        var gender = idNumber.charAt(16) % 2 === 1 ? '男' : '女';

        return { age: age, gender: gender };
      },
      inputIdCard() {
        console.log(22222, this.form.patientIdCard);
        this.isCalc = false;
        let res = this.calculateAgeAndGender(this.form.patientIdCard);

        console.log(res);
        if (res.age) {
          this.isCalc = true;
          // 计算成功
          this.form.age = res.age;
          this.form.gender = res.gender;
        } else {
          console.log(12300);
          this.isCalc = false;
        }

        // 判断年龄
        if (res.age > 75) {
          this.form.ageOver75 = '是';
        } else {
          this.form.ageOver75 = '否';
        }

        if (res.age < 75 && res.age > 65) {
          this.form.age60To75 = '是';
        } else {
          this.form.age60To75 = '否';
        }
      },
    },
  };
</script>
<style>
  .home-view {
    background-color: #f6f7f6;
    .van-cell {
      padding: 11.5px 16px !important;
      background-color: transparent !important;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eeeeee;
    }
    .van-cell__title,
    .van-cell__value {
      flex: none !important;
      width: auto !important;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 2px;
      margin: 20px 0 12px 16px;
    }
    .title:before {
      content: '';
      display: inline-block;
      height: 8px;
      width: 8px;
      background-color: #2eb16e;
      margin-right: 4px;
      border-radius: 50%;
    }
    .card {
      margin: 0 16px;
      border-radius: 10px;
      background-color: #fff;
    }

    .van-field__control {
      text-align: right !important;
    }

    .van-field__label {
      color: rgba(0, 0, 0, 0.8) !important;
    }
    .van-radio__icon--checked .van-icon {
      background-color: #2eb16e !important;
      border-color: #2eb16e !important;
    }
  }
</style>
